import type { SubjectUserPayload } from '@Application/Subjects/Members/Actions/subjectUsersFetched';

/** A user of the facility, with whether they can be made a member of the dossier. */
class SubjectUserView {
	readonly id: number;
	readonly firstName: string;
	readonly lastName: string;
	readonly canBeMember: boolean;

	constructor(payload: SubjectUserPayload) {
		this.id = payload.id;
		this.firstName = payload.firstName;
		this.lastName = payload.lastName;
		this.canBeMember = payload.canBeMember;

		Object.freeze(this);
	}

	get fullName(): string {
		return `${this.firstName} ${this.lastName}`;
	}
}

export default SubjectUserView;
